import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'a1-label',
  styleUrl: 'a1-label.scss',
  scoped: true,
})
export class A1Label {
  /**
   * Label text.
   */
  @Prop({ reflect: true }) text: string = '';

  /**
   * The id of the input element this label is associated with.
   */
  @Prop({ reflect: true }) forInput: string = '';

  /**
   * Toggle for enabling / disabling label's optional text.
   */
  @Prop({ reflect: true }) optional: boolean = false;

  /**
   * Text describing the label's associated input as optional.
   */
  @Prop({ reflect: true }) optionalText: string = '(optional)';

  /**
   * Infopoint to the right of the label text.
   */
  @Prop({ reflect: true }) information: boolean = false;

  /**
   * Toggle for enabling / disabling label.
   */
  @Prop({ reflect: true }) disabled: boolean = false;

  render() {
    return (
      <label class={this.disabled ? 'label-disabled' : ''} htmlFor={this.forInput}>
        {this.text}
        {this.optional ? <span class="label-optional">{this.optionalText}</span> : null}
        {this.information ? <i class="icon icon--info-circle-o"></i> : null}
      </label>
    );
  }
}
